export enum InclusionCategory {
  INDOOR = "indoor",
  KITCHEN = "kitchen",
  BATHROOM_LAUNDRY = "bathroom_laundry",
  OUTDOOR = "outdoor",
}
